import React, { Component } from 'react'
import lang from '../lang'
import langM from '../lang'
import { getlang, setlang } from 'src/helper/getlang'
import './index.less'

export default class extends Component {
  constructor(props) {
    super(props)
  }
  render() {
    let { language, lang } = this.props
    const { show } = this.props
    return (
      <div style={{ display: show }} className="container1">
        <div className="mark"></div>
        <div className="reminder-wrap">
          <div className="title">Rule</div>
          <div className="desc">{lang.tips}</div>
          <div className="close" onClick={() => this.props.changeShow()}></div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/pages/activity/national/Reminder/index.js